
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gT3Lv", function(module, exports) {
/**
 * Gated entry point for the TWG Explorer section.
 *
 * Guards rendering behind the `cc-ai-twg-visualization` experiment and
 * wraps the lazy-loaded inner content in a `TransparentErrorBoundary`
 * so that failures in the graph section never break the space overview
 * page.
 */ 
var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $hSqtY = parcelRequire("hSqtY");


var $lgZ43 = parcelRequire("lgZ43");


var $ipkS0 = parcelRequire("ipkS0");


const $f6c80e4b0ee51d27$var$TwgExplorerSectionContent = /*#__PURE__*/ (0, $cozmU.lazy)((0, $ipkS0.trackReactLazy)("rl-lTcFAC", ()=>(parcelRequire("lyzDH")).then((mod)=>({
            default: mod.TwgExplorerSectionContent
        }))));
function $f6c80e4b0ee51d27$export$c4f05f9024addada({ cloudId: cloudId, spaceId: spaceId, testId: testId }) {
    if (!(0, $6mKj3.expVal)('cc-ai-twg-visualization', 'isEnabled', false)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: "twg-explorer-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lgZ43.TwgExplorerSectionLoadingPlaceholder), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f6c80e4b0ee51d27$var$TwgExplorerSectionContent, {
        cloudId: cloudId,
        spaceId: spaceId,
        testId: testId
    })));
}
Object.assign($f6c80e4b0ee51d27$export$c4f05f9024addada, {
    displayName: 'TwgExplorerSection'
});
module.exports["TwgExplorerSection"] = $f6c80e4b0ee51d27$export$c4f05f9024addada;

});

parcelRegister("lyzDH", function(module, exports) {

let $fb186b27b0df3c24$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fb186b27b0df3c24$var$load("30iG7"),
    $fb186b27b0df3c24$var$load("cvcNg"),
    $fb186b27b0df3c24$var$load("6wr18"),
    $fb186b27b0df3c24$var$load("7Wsg9"),
    $fb186b27b0df3c24$var$load("1aqfs"),
    $fb186b27b0df3c24$var$load("ffEVr"),
    $fb186b27b0df3c24$var$load("60PUI"),
    $fb186b27b0df3c24$var$load("1xeJ3"),
    $fb186b27b0df3c24$var$load("ksZv4"),
    $fb186b27b0df3c24$var$load("hBm54")
]).then(()=>parcelRequire('8S2kV'));

});


//# sourceMappingURL=TwgExplorerSection.0a10d8c4.js.map
